@if (!field.hide && !field.parent?.hide) {
    <app-product-ecommerce-widget></app-product-ecommerce-widget>
}
